export default "__VITE_ASSET__21baf4aa__"